export function usePathname(): string {
  return window.location.pathname
}

export function useSearchParams(): URLSearchParams {
  return new URLSearchParams(window.location.search)
}
